import { useCallback, useState } from 'react';

interface FormDataConfig {
  fields: FormDataField[];
}

interface FormDataField {
  id: string;
  type: FieldType;
  required: boolean;
  fieldName: string;
}

type FieldType = 'text' | 'number' | 'email' | 'phone' | 'date' | 'checkbox' | 'radio' | 'select' | 'textarea';

export function useFormData(config: FormDataConfig) {  
  const [ errors, setError ] = useState([]);
  
  const handleData = useCallback(
    () => {  
      const payload = {} as Record<string, string | boolean>;
      
      config.fields.forEach(({ id, type, required, fieldName }) => {
        payload[fieldName] = getField(id, type);

        if (!payload[fieldName] && required) {
          setError([ ...errors, `Field ${id} is required` ]);
        }
      });

      return payload;
    },
    [ config.fields, errors ]
  );

  return { 
    handleData,
    errors
  };
}

function getField(id: string, type: FieldType) {
  if (type === 'checkbox') {
    return (document.getElementById(id) as HTMLInputElement).checked;
  }

  return (document.getElementById(id) as HTMLInputElement).value;
}